import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";
// Replace with your actual Firebase configuration from the Firebase console
const firebaseConfig = {
  apiKey: "AIzaSyDoJxxk0WVemDWuf3URKjNCHdGNG4cpjLU",
  authDomain: "wassel-455714.firebaseapp.com",
  databaseURL: "https://wassel-455714-7d18c.firebaseio.com/", // Rider applications RTDB
  projectId: "wassel-455714",
  storageBucket: "wassel-455714.appspot.com",
  messagingSenderId: "782844555139",
  appId: "1:782844555139:web:7a3029b81c22d9ea9810b6",
  measurementId: "G-5HT0WYJBCQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);

export { app, database, auth, analytics }; 